import index from "./ezam_transit_check.vue";
export default index;
